import React, { useEffect, useState } from "react";

import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";

const useStyle = makeStyles({
  botaoPaginacao: {
    width: 42,
    height: 42,
    borderRadius: 4,
    border: "solid 1px #97c1ff",
    backgroundColor: "white",
    color: "#044ada",
    margin: 5,
    padding: 0,
    "&hover:": {
      backgroundColor: "#edf4ff",
    },
  },
  botaoPaginacaoSelecionado: {
    width: 42,
    height: 42,
    borderRadius: 4,
    border: "solid 1px #97c1ff",
    backgroundColor: "#044ada",
    color: "white",
    fontWeight: 500,
    fontSize: "IBM Plex Sans",
    margin: 5,
    padding: 0,
    "&:hover": {
      backgroundColor: "#0430ad",
    },
  },
});

const Pagination = (props) => {
  const { pagina, totalDePaginas, onChangePage } = props;

  const botoes = () => {
    const itens = [];
    for (let i = pagina - 2; i <= pagina + 2; i++) {
      if (i >= 0 && i <= totalDePaginas - 1) {
        itens.push(
          <Button
            key={i}
            disabled={pagina === i}
            variant={i === pagina ? "contained" : "outlined"}
            style={{ margin: "0 2px" }}
            onClick={() => onChangePage(i)}
          >
            {i + 1}
          </Button>
        );
      }
    }
    return itens;
  };

  const arrayFromIndex = () => {
    let retorno = [];
    for (let i = 0; i <= totalDePaginas - 1; i++) {
      if (
        i === pagina ||
        i === pagina - 1 ||
        i === pagina - 2 ||
        i === pagina + 1 ||
        i === pagina + 2
      ) {
        continue;
      } else {
        retorno.push(i);
      }
    }
    return retorno;
  };

  const handlePagination = (page) => {
    if (page < 0 || page > totalDePaginas - 1) {
      return;
    }
    onChangePage(page);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            flexWrap: "wrap",
            justifyContent: "flex-start",
          }}
        />
        <div style={{ marginTop: 20, gap: "0 10px" }}>
          {
            <>
              <Button
                style={{ marginLeft: 2 }}
                variant="outlined"
                disabled={pagina < 1}
                onClick={() => handlePagination(0)}
              >
                {" "}
                primeiro{" "}
              </Button>
              <Button
                style={{ marginRight: 2 }}
                variant="outlined"
                disabled={pagina < 1}
                onClick={() => handlePagination(pagina - 1)}
              >
                {" "}
                <ArrowBackIcon />{" "}
              </Button>
              {pagina <= 3 ? "" : <MoreHorizIcon />}
              {botoes()}
              {pagina > totalDePaginas - 3 ? "" : <MoreHorizIcon />}
              <Button
                style={{ marginLeft: 2 }}
                variant="outlined"
                disabled={pagina >= totalDePaginas - 1}
                onClick={() => handlePagination(pagina + 1)}
              >
                {" "}
                <ArrowForwardIcon />{" "}
              </Button>
              <Button
                style={{ marginLeft: 2 }}
                variant="outlined"
                disabled={pagina >= totalDePaginas - 1}
                onClick={() => handlePagination(totalDePaginas - 1)}
              >
                {" "}
                último{" "}
              </Button>

              <Select
                style={{ marginLeft: "5px" }}
                value={pagina}
                onChange={(e) => handlePagination(e.target.value)}
              >
                <MenuItem value={pagina} disabled>
                  {pagina + 1}
                </MenuItem>
                {arrayFromIndex().map((item) => (
                  <MenuItem value={item} key={item}>
                    {item + 1}
                  </MenuItem>
                ))}
              </Select>
            </>
          }
        </div>
      </div>
    </>
  );
};

export default Pagination;
